// // import React, { useState, useEffect } from "react";
// // import apiService from "../../Common/Configurations/APIService";
// // import config from "../../Common/Configurations/APIConfig";
// // import { useAuth } from "../../Common/Configurations/AuthContext";
// // import moment from "moment";

// // const StatementOfAccount = () => {
// //   const { user } = useAuth();
// //   const [statement, setStatement] = useState(null);
// //   const [parties, setParties] = useState([]); // Combined list of Customers/Suppliers
// //   const [selectedRefId, setSelectedRefId] = useState("");
// //   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
// //   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
// //   const [loading, setLoading] = useState(false);

// //   // Fetch all potential parties for the dropdown
// //   useEffect(() => {
// //     const fetchParties = async () => {
// //       const customers = await apiService.getAll(`${config.GETALLCUSTOMERSBYCOMPANYID}/${user.cid}`);
// //       const suppliers = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=SUPPLIER&parentCompanyId=${user.cid}`);
// //       const corporates = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=CORPORATE&parentCompanyId=${user.cid}`);
// //       const combined = [
// //         ...customers.map(c => ({ id: c.customerId, name: `[Agent] ${c.customerName}` })),
// //         ...suppliers.map(s => ({ id: s.companyId, name: `[Supplier] ${s.companyName}` })),
// //         ...corporates.map(c => ({ id: c.companyId, name: `[Corporate] ${c.companyName}` })),
// //       ];
// //       setParties(combined);
// //     };
// //     if (user?.cid) fetchParties();
// //   }, [user?.cid]);

// //   const fetchStatement = async () => {
// //     if (!selectedRefId) return alert("Please select a party");
// //     setLoading(true);
// //     try {
// //       const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
// //       setStatement(res);
// //     } catch (error) {
// //       console.error(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

// //   return (
// //     <div className="p-4 bg-white" style={{ minHeight: "100vh" }}>
// //       <h3 className="mb-4 text-primary">Statement of Account</h3>

// //       {/* Filter Bar */}
// //       <div className="row g-3 mb-4 p-3 bg-light rounded shadow-sm no-print">
// //         <div className="col-md-4">
// //           <label className="small fw-bold">Select Agent / Supplier</label>
// //           <select className="form-select" value={selectedRefId} onChange={e => setSelectedRefId(e.target.value)}>
// //             <option value="">-- Choose Party --</option>
// //             {parties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
// //           </select>
// //         </div>
// //         <div className="col-md-3">
// //           <label className="small fw-bold">From</label>
// //           <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} />
// //         </div>
// //         <div className="col-md-3">
// //           <label className="small fw-bold">To</label>
// //           <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} />
// //         </div>
// //         <div className="col-md-2 d-flex align-items-end">
// //           <button className="btn btn-primary w-100" onClick={fetchStatement} disabled={loading}>
// //             {loading ? "Loading..." : "View Ledger"}
// //           </button>
// //         </div>
// //       </div>

// //       {statement && (
// //         <div className="statement-content mt-4">
// //           <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
// //             <div>
// //               <h4 className="m-0">{statement.partyName}</h4>
// //               <p className="text-muted small">Statement Period: {moment(fromDate).format("LL")} - {moment(toDate).format("LL")}</p>
// //             </div>
// //             <div className="text-end">
// //               <h6 className="text-muted mb-0">Balance Due</h6>
// //               <h3 className={statement.closingBalance >= 0 ? "text-danger" : "text-success"}>
// //                  ₹ {format(Math.abs(statement.closingBalance))}
// //                  <small className="fs-6">{statement.closingBalance >= 0 ? " Dr" : " Cr"}</small>
// //               </h3>
// //             </div>
// //           </div>

// //           <table className="table table-bordered table-striped">
// //             <thead className="table-dark">
// //               <tr>
// //                 <th>Date</th>
// //                 <th>Description</th>
// //                 <th>Voucher #</th>
// //                 <th className="text-end">Debit (Dr)</th>
// //                 <th className="text-end">Credit (Cr)</th>
// //                 <th className="text-end">Balance</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               <tr>
// //                 <td colSpan="3" className="fw-bold">Opening Balance</td>
// //                 <td colSpan="2"></td>
// //                 <td className="text-end fw-bold">{format(statement.openingBalance)}</td>
// //               </tr>
// //               {statement.transactions.map((t, i) => (
// //                 <tr key={i}>
// //                   <td>{moment(t.date).format("DD/MM/YYYY")}</td>
// //                   <td className="small">{t.description}</td>
// //                   <td className="small">{t.invoiceNumber}</td>
// //                   <td className="text-end">{t.debit > 0 ? format(t.debit) : "-"}</td>
// //                   <td className="text-end">{t.credit > 0 ? format(t.credit) : "-"}</td>
// //                   <td className="text-end fw-bold">{format(t.runningBalance)}</td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //             <tfoot className="table-secondary fw-bold">
// //               <tr>
// //                 <td colSpan="3">Period Totals</td>
// //                 <td className="text-end">{format(statement.totalDebit)}</td>
// //                 <td className="text-end">{format(statement.totalCredit)}</td>
// //                 <td className="text-end text-primary" style={{fontSize: '1.2rem'}}>{format(statement.closingBalance)}</td>
// //               </tr>
// //             </tfoot>
// //           </table>
// //           <button className="btn btn-outline-secondary no-print mt-3" onClick={() => window.print()}>Print Statement</button>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default StatementOfAccount;

// import React, { useState, useEffect } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";
// import SupplierPaymentModal from "./SupplierPaymentModal"; // Import the Modal

// const StatementOfAccount = () => {
//   const { user } = useAuth();
//   const [statement, setStatement] = useState(null);
//   const [parties, setParties] = useState([]); // Combined list of Customers/Suppliers
//   const [selectedRefId, setSelectedRefId] = useState("");
//   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
//   const [loading, setLoading] = useState(false);

//   // ✅ State to control the Modal
//   const [showPaymentModal, setShowPaymentModal] = useState(false);

//   // Fetch all potential parties for the dropdown
//   useEffect(() => {
//     const fetchParties = async () => {
//       const customers = await apiService.getAll(`${config.GETALLCUSTOMERSBYCOMPANYID}/${user.cid}`);
//       const suppliers = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=SUPPLIER&parentCompanyId=${user.cid}`);
//       const corporates = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=CORPORATE&parentCompanyId=${user.cid}`);
//       const combined = [
//         ...customers.map(c => ({ id: c.customerId, name: `[Agent] ${c.customerName}`, type: 'SALE' })),
//         ...suppliers.map(s => ({ id: s.companyId, name: `[Supplier] ${s.companyName}`, type: 'PURCHASE' })),
//         ...corporates.map(c => ({ id: c.companyId, name: `[Corporate] ${c.companyName}`, type: 'PURCHASE' })),
//       ];
//       setParties(combined);
//     };
//     if (user?.cid) fetchParties();
//   }, [user?.cid]);

//   const fetchStatement = async () => {
//     if (!selectedRefId) return alert("Please select a party");
//     setLoading(true);
//     try {
//       const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
//       setStatement(res);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

//   // ✅ Determine if the selected party is a Supplier or Corporate
//   const isSupplierOrCorporate = parties.find(p => p.id === selectedRefId)?.type === 'PURCHASE';

//   return (
//     <div className="p-4 bg-white" style={{ minHeight: "100vh" }}>
//       <h3 className="mb-4 text-primary">Statement of Account</h3>

//       {/* Filter Bar */}
//       <div className="row g-3 mb-4 p-3 bg-light rounded shadow-sm no-print">
//         <div className="col-md-4">
//           <label className="small fw-bold">Select Agent / Supplier</label>
//           <select className="form-select" value={selectedRefId} onChange={e => setSelectedRefId(e.target.value)}>
//             <option value="">-- Choose Party --</option>
//             {parties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
//           </select>
//         </div>
//         <div className="col-md-3">
//           <label className="small fw-bold">From</label>
//           <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} />
//         </div>
//         <div className="col-md-3">
//           <label className="small fw-bold">To</label>
//           <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} />
//         </div>
//         <div className="col-md-2 d-flex align-items-end">
//           <button className="btn btn-primary w-100" onClick={fetchStatement} disabled={loading}>
//             {loading ? "Loading..." : "View Ledger"}
//           </button>
//         </div>
//       </div>

//       {statement && (
//         <div className="statement-content mt-4">
//           <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
//             <div>
//               <h4 className="m-0">{statement.partyName || parties.find(p => p.id === selectedRefId)?.name}</h4>
//               <p className="text-muted small">Statement Period: {moment(fromDate).format("LL")} - {moment(toDate).format("LL")}</p>
//             </div>
//             <div className="text-end">
//               <h6 className="text-muted mb-0">Balance Due</h6>
//               <h3 className={statement.closingBalance >= 0 ? "text-danger" : "text-success"}>
//                  ₹ {format(Math.abs(statement.closingBalance))}
//                  <small className="fs-6">{statement.closingBalance >= 0 ? " Dr" : " Cr"}</small>
//               </h3>
              
//               {/* ✅ ADDED: Record Payment Button (Only for Suppliers/Corporates with a balance) */}
//               {isSupplierOrCorporate && Math.abs(statement.closingBalance) > 0 && (
//                 <button 
//                   className="btn btn-sm btn-success mt-2 no-print" 
//                   onClick={() => setShowPaymentModal(true)}
//                 >
//                   Record Payment to Supplier
//                 </button>
//               )}
//             </div>
//           </div>

//           <table className="table table-bordered table-striped">
//             <thead className="table-dark">
//               <tr>
//                 <th>Date</th>
//                 <th>Description</th>
//                 <th>Voucher #</th>
//                 <th className="text-end">Debit (Dr)</th>
//                 <th className="text-end">Credit (Cr)</th>
//                 <th className="text-end">Balance</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td colSpan="3" className="fw-bold">Opening Balance</td>
//                 <td colSpan="2"></td>
//                 <td className="text-end fw-bold">{format(statement.openingBalance)}</td>
//               </tr>
//               {statement.transactions.map((t, i) => (
//                 <tr key={i}>
//                   <td>{moment(t.date).format("DD/MM/YYYY")}</td>
//                   <td className="small">{t.description}</td>
//                   <td className="small">{t.invoiceNumber}</td>
//                   <td className="text-end">{t.debit > 0 ? format(t.debit) : "-"}</td>
//                   <td className="text-end">{t.credit > 0 ? format(t.credit) : "-"}</td>
//                   <td className="text-end fw-bold">{format(t.runningBalance)}</td>
//                 </tr>
//               ))}
//             </tbody>
//             <tfoot className="table-secondary fw-bold">
//               <tr>
//                 <td colSpan="3">Period Totals</td>
//                 <td className="text-end">{format(statement.totalDebit)}</td>
//                 <td className="text-end">{format(statement.totalCredit)}</td>
//                 <td className="text-end text-primary" style={{fontSize: '1.2rem'}}>{format(statement.closingBalance)}</td>
//               </tr>
//             </tfoot>
//           </table>
//           <button className="btn btn-outline-secondary no-print mt-3" onClick={() => window.print()}>Print Statement</button>
//         </div>
//       )}

//       {/* ✅ Modal Component */}
//       {showPaymentModal && (
//         <SupplierPaymentModal 
//           supplierId={selectedRefId}
//           supplierName={statement?.partyName || "Supplier"}
//           balance={statement?.closingBalance || 0}
//           companyId={user.cid}
//           onClose={() => setShowPaymentModal(false)}
//           onSuccess={fetchStatement} // Refresh ledger after payment
//         />
//       )}
//     </div>
//   );
// };

// export default StatementOfAccount;

import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import SupplierPaymentModal from "./SupplierPaymentModal"; 
import Header from "../../Common/Layout/Header"; // Ensuring Header is used
import AccountTabs from "../AllTabs/AccountTabs";

const StatementOfAccount = () => {
  const { user } = useAuth();
  const [statement, setStatement] = useState(null);
  const [parties, setParties] = useState([]); 
  const [selectedRefId, setSelectedRefId] = useState("");
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const fetchParties = async () => {
      const customers = await apiService.getAll(`${config.GETALLCUSTOMERSBYCOMPANYID}/${user.cid}`);
      const suppliers = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=SUPPLIER&parentCompanyId=${user.cid}`);
      const corporates = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=CORPORATE&parentCompanyId=${user.cid}`);
      const combined = [
        ...customers.map(c => ({ id: c.customerId, name: `[Agent] ${c.customerName}`, type: 'SALE' })),
        ...suppliers.map(s => ({ id: s.companyId, name: `[Supplier] ${s.companyName}`, type: 'PURCHASE' })),
        ...corporates.map(c => ({ id: c.companyId, name: `[Corporate] ${c.companyName}`, type: 'PURCHASE' })),
      ];
      setParties(combined);
    };
    if (user?.cid) fetchParties();
  }, [user?.cid]);

  const fetchStatement = async () => {
    if (!selectedRefId) return alert("Please select a party");
    setLoading(true);
    try {
      const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
      setStatement(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });
  const isSupplierOrCorporate = parties.find(p => p.id === selectedRefId)?.type === 'PURCHASE';

  return (
    <div className="ledger-main-wrapper">
       
       <Header User={user} /> 
       <div className="p-2">
        <AccountTabs activeTab="STATEMENTOFACCOUNT" />
        </div>
      <div className="report-container">
        
        {/* Header Section */}
        <div className="report-header">
          <div>
            <h2 className="report-title">Statement of Account</h2>
            <p className="company-id">General Ledger & Transaction History</p>
          </div>
        </div>

        {/* Filter Bar */}
        <div className="filter-bar no-print">
          <div className="filter-group flex-grow">
            <label>Select Agent / Supplier</label>
            <select className="custom-input" value={selectedRefId} onChange={e => setSelectedRefId(e.target.value)}>
              <option value="">-- Choose Party --</option>
              {parties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div className="filter-group">
            <label>From Date</label>
            <input type="date" className="custom-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
          </div>
          <div className="filter-group">
            <label>To Date</label>
            <input type="date" className="custom-input" value={toDate} onChange={e => setToDate(e.target.value)} />
          </div>
          <div className="filter-group btn-group">
            <button className="search-button" onClick={fetchStatement} disabled={loading}>
              {loading ? "FETCHING..." : "VIEW LEDGER"}
            </button>
          </div>
        </div>

        {statement && (
          <div className="statement-content">
            
            {/* Statement Summary Box */}
            <div className="statement-summary">
              <div className="party-details">
                <h4>{statement.partyName || parties.find(p => p.id === selectedRefId)?.name}</h4>
                <p>Statement Period: <strong>{moment(fromDate).format("DD MMM YYYY")}</strong> to <strong>{moment(toDate).format("DD MMM YYYY")}</strong></p>
              </div>
              
              <div className="balance-section text-end">
                <div className="balance-label">Closing Balance</div>
                <div className={`balance-amount ${statement.closingBalance >= 0 ? "text-red" : "text-green"}`}>
                   ₹ {format(Math.abs(statement.closingBalance))}
                   <span className="dr-cr-badge">{statement.closingBalance >= 0 ? "DR" : "CR"}</span>
                </div>
                
                {isSupplierOrCorporate && Math.abs(statement.closingBalance) > 0 && (
                  <button 
                    className="payment-btn no-print" 
                    onClick={() => setShowPaymentModal(true)}
                  >
                    Record Payment
                  </button>
                )}
              </div>
            </div>

            {/* Ledger Table */}
            <div className="table-responsive">
              <table className="ledger-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Voucher #</th>
                    <th className="text-end">Debit (Dr)</th>
                    <th className="text-end">Credit (Cr)</th>
                    <th className="text-end">Run. Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Opening Balance Row */}
                  <tr className="opening-balance-row">
                    <td colSpan="3"><strong>Opening Balance</strong></td>
                    <td colSpan="2"></td>
                    <td className="text-end font-bold">{format(statement.openingBalance)}</td>
                  </tr>

                  {/* Transactions */}
                  {statement.transactions.map((t, i) => (
                    <tr key={i} className="transaction-row">
                      <td className="date-col">{moment(t.date).format("DD/MM/YYYY")}</td>
                      <td className="desc-col">{t.description}</td>
                      <td className="voucher-col">{t.invoiceNumber}</td>
                      <td className="text-end text-red">{t.debit > 0 ? format(t.debit) : "-"}</td>
                      <td className="text-end text-green">{t.credit > 0 ? format(t.credit) : "-"}</td>
                      <td className="text-end font-bold text-dark">{format(t.runningBalance)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="footer-row">
                    <td colSpan="3">Period Totals</td>
                    <td className="text-end text-red">{format(statement.totalDebit)}</td>
                    <td className="text-end text-green">{format(statement.totalCredit)}</td>
                    <td className="text-end highlight-total">{format(statement.closingBalance)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="action-footer no-print">
               <button className="print-btn" onClick={() => window.print()}>
                 <i className="fa fa-print"></i> Print Statement
               </button>
            </div>
          </div>
        )}

        {showPaymentModal && (
          <SupplierPaymentModal 
            supplierId={selectedRefId}
            supplierName={statement?.partyName || "Supplier"}
            balance={statement?.closingBalance || 0}
            companyId={user.cid}
            onClose={() => setShowPaymentModal(false)}
            onSuccess={fetchStatement} 
          />
        )}
      </div>

      <style jsx>{`
        .ledger-main-wrapper {
          padding: 30px;
          background-color: #f4f7f6;
          min-height: 100vh;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .report-container {
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          overflow: hidden;
          border-top: 5px solid #0056b3;
          max-width: 1100px;
          margin: 0 auto;
        }

        /* --- Header --- */
        .report-header {
          background-color: #0056b3;
          color: white;
          padding: 20px 30px;
        }
        .report-title { margin: 0; font-size: 24px; font-weight: 600; color: #fff; }
        .company-id { margin: 0; font-size: 13px; opacity: 0.8; margin-top: 4px; }

        /* --- Filter Bar --- */
        .filter-bar {
          padding: 20px 30px;
          background-color: #f8f9fa;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          gap: 15px;
          align-items: flex-end;
        }
        .filter-group { display: flex; flex-direction: column; }
        .filter-group.flex-grow { flex: 1; }
        .filter-group label {
          font-size: 12px; font-weight: 600; color: #6c757d; margin-bottom: 5px; text-transform: uppercase;
        }
        .custom-input {
          padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px; font-size: 14px; color: #495057; outline: none;
        }
        .custom-input:focus { border-color: #0056b3; }
        
        .search-button {
          padding: 9px 20px; background-color: #0056b3; color: white; border: none; border-radius: 4px; font-weight: 600; cursor: pointer; text-transform: uppercase; font-size: 13px;
        }
        .search-button:hover { background-color: #004494; }

        /* --- Statement Summary --- */
        .statement-content { padding: 30px; }
        
        .statement-summary {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          background: #fff;
          padding-bottom: 20px;
          border-bottom: 2px solid #e9ecef;
          margin-bottom: 20px;
        }
        .party-details h4 { margin: 0 0 5px 0; color: #343a40; font-size: 20px; }
        .party-details p { margin: 0; color: #6c757d; font-size: 14px; }
        
        .balance-section { text-align: right; }
        .balance-label { font-size: 12px; color: #6c757d; text-transform: uppercase; font-weight: 700; }
        .balance-amount { font-size: 28px; font-weight: 700; line-height: 1.2; }
        .dr-cr-badge { font-size: 14px; padding: 2px 6px; background: #eee; border-radius: 4px; margin-left: 8px; vertical-align: middle; color: #555; }
        
        .text-red { color: #dc3545; }
        .text-green { color: #28a745; }
        .text-dark { color: #343a40; }
        
        .payment-btn {
          margin-top: 10px; background-color: #28a745; color: white; border: none; padding: 6px 12px; font-size: 12px; border-radius: 4px; cursor: pointer; font-weight: 600;
        }
        .payment-btn:hover { background-color: #218838; }

        /* --- Table Design --- */
        .ledger-table { width: 100%; border-collapse: collapse; font-size: 14px; }
        .ledger-table th {
          background-color: #f1f3f5; color: #495057; font-weight: 700; text-transform: uppercase; font-size: 12px; padding: 12px 10px; border-bottom: 2px solid #dee2e6; text-align: left;
        }
        .text-end { text-align: right; }
        
        .transaction-row td { padding: 10px 10px; border-bottom: 1px solid #e9ecef; color: #495057; }
        .transaction-row:nth-child(even) { background-color: #f8f9fa; }
        
        .opening-balance-row td {
          background-color: #fff9db; padding: 12px 10px; border-bottom: 1px solid #e9ecef; color: #495057; font-style: italic;
        }

        .date-col { width: 100px; }
        .voucher-col { width: 120px; }
        .font-bold { font-weight: 700; }

        .footer-row td {
          background-color: #e9ecef; font-weight: 700; padding: 12px 10px; border-top: 2px solid #dee2e6; color: #343a40;
        }
        .highlight-total { color: #0056b3; font-size: 15px; }

        .action-footer { margin-top: 20px; text-align: right; }
        .print-btn {
          background: #fff; border: 1px solid #ced4da; color: #495057; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 600;
        }
        .print-btn:hover { background: #e2e6ea; }

        /* Print Specifics */
        @media print {
          .no-print, .filter-bar, .action-footer, .payment-btn { display: none !important; }
          .ledger-main-wrapper { padding: 0; background: white; }
          .report-container { box-shadow: none; border: none; max-width: 100%; }
          .report-header { background: white; color: black; border-bottom: 2px solid #000; padding: 0 0 10px 0; }
          .report-title { color: black; }
        }
      `}</style>
    </div>
  );
};

export default StatementOfAccount;